import React, { useEffect, useState } from 'react';
import SelectField from '../../../../FormControl/input/SelectField';
import { Skeleton, Typography } from '@mui/material';
import { handlerErrorV2 } from '../../../../../utils/errors';
import { getSettingSubModule } from '../../../../../services/periodical-report/periodical-report-setting.service';

const SelectPeriod = ({ id, name, value, error, disabled, isPreview, loading, onChange  }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorFetch, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await getSettingSubModule('period');
        if (!response?.data && response?.error) {
          setError(response.error.message || 'An error ocurred');
        } else {
          setData(response?.data || null);
        }
      } catch (error) {
        const message = handlerErrorV2(error);
        setError(message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  if (isPreview) {
    return (
      <Typography>{isLoading ? <Skeleton /> : data?.find((item) => item._id === value)?.name}</Typography>
    );
  }

  return (
    <SelectField
      id={id}
      error={errorFetch || error}
      helperText={errorFetch || error}
      value={value}
      name={name}
      onChange={onChange}
      options={data?.map((item) => ({ value: item._id, label: item.name })) || []}
      placeholder='Choose a period'
      loading={isLoading || loading}
      disabled={isLoading || disabled || loading}
    />
  );
};

export default SelectPeriod;
